// extracted by mini-css-extract-plugin
export default {"loader_container":"Loader_loader_container__D03q1","spinner":"Loader_spinner__DRafB","spin":"Loader_spin__xLcoR","text":"Loader_text__dK8rk"};